export const FETCH_TOP_RANKED_MEN = 'TOP_RANKED:FETCH_MEN';
export const FETCH_TOP_RANKED_MEN_SUCCESS = 'TOP_RANKED:FETCH_MEN_SUCCESS';
export const FETCH_TOP_RANKED_MEN_FAILURE = 'TOP_RANKED:FETCH_MEN_FAILURE';

export const FETCH_TOP_RANKED_WOMEN = 'TOP_RANKED:FETCH_WOMEN';
export const FETCH_TOP_RANKED_WOMEN_SUCCESS = 'TOP_RANKED:FETCH_WOMEN_SUCCESS';
export const FETCH_TOP_RANKED_WOMEN_FAILURE = 'TOP_RANKED:FETCH_WOMEN_FAILURE';

export const FETCH_TOP_RANKED = 'TOP_RANKED:FETCH';
export const FETCH_TOP_RANKED_SUCCESS = 'TOP_RANKED:FETCH_SUCCESS';

export const fetchTopMen = (count) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_TOP_RANKED_MEN });
    try {
        const res = await mainApi.get(`v1/player/top?gender=M&count=${count}`);
        const { data } = res;
        if (data.error) {
            dispatch({ type: FETCH_TOP_RANKED_MEN_FAILURE, data: data.error });
        } else {
            dispatch({ type: FETCH_TOP_RANKED_MEN_SUCCESS, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_TOP_RANKED_MEN_FAILURE });
    }
};

export const fetchTopWomen = (count) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_TOP_RANKED_WOMEN });
    try {
        const res = await mainApi.get(`v1/player/top?gender=F&count=${count}`);
        const { data } = res;
        if (data.error) {
            dispatch({ type: FETCH_TOP_RANKED_WOMEN_FAILURE, data: data.error });
        } else {
            dispatch({ type: FETCH_TOP_RANKED_WOMEN_SUCCESS, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_TOP_RANKED_WOMEN_FAILURE });
    }
};

export const fetchTopMenByTags = (tags, template, count) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_TOP_RANKED_MEN });
    try {
        const res = await mainApi.get(`v2/player/top?gender=M${tags ? `&tags=${tags}` : ''}${template ? `&template=${template}` : ''}${count && count > 0 ? `&count=${count}` : ''}`);
        const { data } = res;
        if (data.error) {
            dispatch({ type: FETCH_TOP_RANKED_MEN_FAILURE, data: data.error });
        } else {
            dispatch({ type: FETCH_TOP_RANKED_MEN_SUCCESS, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_TOP_RANKED_MEN_FAILURE });
    }
};

export const fetchTopWomenByTags = (tags, template, count) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_TOP_RANKED_WOMEN });
    try {
        const res = await mainApi.get(`v2/player/top?gender=F${tags ? `&tags=${tags}` : ''}${template ? `&template=${template}` : ''}${count && count > 0 ? `&count=${count}` : ''}`);
        const { data } = res;
        if (data.error) {
            dispatch({ type: FETCH_TOP_RANKED_WOMEN_FAILURE, data: data.error });
        } else {
            dispatch({ type: FETCH_TOP_RANKED_WOMEN_SUCCESS, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_TOP_RANKED_WOMEN_FAILURE });
    }
};

export const fetchRankingsData = ({ tags, template, count }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_TOP_RANKED });

    const mensResults = await mainApi.get(`v2/player/top?gender=M${tags ? `&tags=${tags}` : ''}${template ? `&template=${template}` : ''}${count && count > 0 ? `&count=${count}` : ''}`);
    const womensResults = await mainApi.get(`v2/player/top?gender=F${tags ? `&tags=${tags}` : ''}${template ? `&template=${template}` : ''}${count && count > 0 ? `&count=${count}` : ''}`);

    const payload = {
        men: {
            error: (mensResults.error || null),
            players: (!mensResults.error ? mensResults.data : []),
        },
        women: {
            error: (womensResults.error || null),
            players: (!womensResults.error ? womensResults.data : []),
        },
    };

    dispatch({
        type: FETCH_TOP_RANKED_SUCCESS,
        payload,
    });
};
